// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "DoDontRow-module--bx--text-truncate--end--3DMoV";
export var bxTextTruncateFront = "DoDontRow-module--bx--text-truncate--front--3mrmG";
export var caption = "DoDontRow-module--caption--1BQHm";
export var card = "DoDontRow-module--card--1V8Qs";
export var cardContent = "DoDontRow-module--card-content--1zFY1";
export var content = "DoDontRow-module--content--3SKPh";
export var correct = "DoDontRow-module--correct--2Tl-9";
export var dark = "DoDontRow-module--dark--3rbuj";
export var description = "DoDontRow-module--description--T1oRQ";
export var doDontRow = "DoDontRow-module--do-dont-row--117T9";
export var example = "DoDontRow-module--example--2teTl";
export var icon = "DoDontRow-module--icon--B5OpR";
export var iconCorrect = "DoDontRow-module--icon-correct--1vO0C";
export var iconIncorrect = "DoDontRow-module--icon-incorrect--rPq_Q";
export var image = "DoDontRow-module--image--DPRyc";
export var incorrect = "DoDontRow-module--incorrect--KyxwA";
export var ratio = "DoDontRow-module--ratio--35bPM";
export var ratio16x9 = "DoDontRow-module--ratio16x9--3Aau5";
export var ratio1x1 = "DoDontRow-module--ratio1x1--1oNXH";
export var ratio1x2 = "DoDontRow-module--ratio1x2--3d8bz";
export var ratio2x1 = "DoDontRow-module--ratio2x1--bW2-_";
export var ratio3x4 = "DoDontRow-module--ratio3x4--3OfGJ";
export var ratio4x3 = "DoDontRow-module--ratio4x3--1Pqye";
export var ratio9x16 = "DoDontRow-module--ratio9x16--1ZatJ";
export var text = "DoDontRow-module--text--2Sdcc";
export var title = "DoDontRow-module--title--2R7WF";